import ShopsPage from "./ShopsPage";

export default function ShopsInformationPage() {
  return <ShopsPage view="info" />;
}
